import { render, staticRenderFns } from "./goodList.vue?vue&type=template&id=daf6fe96&scoped=true&"
import script from "./goodList.vue?vue&type=script&lang=js&"
export * from "./goodList.vue?vue&type=script&lang=js&"
import style0 from "./goodList.vue?vue&type=style&index=0&id=daf6fe96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf6fe96",
  null
  
)

export default component.exports